import { CLIP_UPDATE_TYPE, VERSION_EDIT_TYPE } from './constants';

const VERSIONS_DESCRIPTION_MAP: Record<string, { category: string; label: string }> = {
  // Trim / Segments
  [CLIP_UPDATE_TYPE.UPDATE_SEGMENT_TRACK]: { category: 'trim', label: 'Trimmed clip' },
  [CLIP_UPDATE_TYPE.UPDATE_VIDEO_SEGMENT_TRACK]: { category: 'trim', label: 'Trimmed clip' },
  [CLIP_UPDATE_TYPE.ADD_SEGMENT_TRACK]: { category: 'intro_outro', label: 'Added intro/outro' },
  [CLIP_UPDATE_TYPE.REMOVE_SEGMENT_TRACK]: { category: 'intro_outro', label: 'Removed intro/outro' },
  [CLIP_UPDATE_TYPE.SPLIT_SEGMENT]: { category: 'split', label: 'Split segment' },
  [CLIP_UPDATE_TYPE.SPLIT_COMPOSITE_SEGMENT]: { category: 'split', label: 'Split segment' },
  [CLIP_UPDATE_TYPE.REORDER_SEGMENTS]: { category: 'split', label: 'Reordered segments' },
  [CLIP_UPDATE_TYPE.CREATE_HOOK]: { category: 'split', label: 'Created hook' },
  [CLIP_UPDATE_TYPE.UPSERT_SEGMENT_TRANSITION_OUT]: { category: 'transition', label: 'Added transition' },
  [CLIP_UPDATE_TYPE.REMOVE_SEGMENT_TRANSITION_OUT]: { category: 'transition', label: 'Removed transition' },

  // Cuts / Deletes
  [CLIP_UPDATE_TYPE.ADD_COMPOSITE_SEGMENT_DELETE]: { category: 'cuts', label: 'Cut segment(s)' },
  [CLIP_UPDATE_TYPE.BULK_ADD_COMPOSITE_SEGMENT_DELETES]: { category: 'cuts', label: 'Cut segment(s)' },
  [CLIP_UPDATE_TYPE.BULK_PUT_COMPOSITE_SEGMENT_DELETE]: { category: 'cuts', label: 'Cut segment(s)' },
  [CLIP_UPDATE_TYPE.UPDATE_COMPOSITE_SEGMENT_DELETE]: { category: 'cuts', label: 'Cut segment(s)' },
  [CLIP_UPDATE_TYPE.ADD_COMPOSITE_SEGMENT_DELETE_WORDS]: { category: 'cuts', label: 'Cut word(s)' },
  [CLIP_UPDATE_TYPE.RESTORE_COMPOSITE_SEGMENT_DELETE]: { category: 'cuts', label: 'Restored cut' },
  [CLIP_UPDATE_TYPE.REMOVE_COMPOSITE_SEGMENT_DELETE]: { category: 'cuts', label: 'Restored cut' },
  [CLIP_UPDATE_TYPE.UPDATE_COMPOSITE_SEGMENT_WORDS]: { category: 'cuts', label: 'Cut segment(s)' },
  [CLIP_UPDATE_TYPE.ADD_COMPOSITE_SEGMENT_EFFECT]: { category: 'effect', label: 'Added zoom effect' },

  // Layout
  [CLIP_UPDATE_TYPE.UPDATE_CLIP_LAYOUT]: { category: 'layout', label: 'Changed layout' },
  [CLIP_UPDATE_TYPE.UPDATE_MAGIC_LAYOUT]: { category: 'layout', label: 'Changed layout' },
  [CLIP_UPDATE_TYPE.UPDATE_CLIP_SIZE]: { category: 'layout', label: 'Changed aspect ratio' },
  [CLIP_UPDATE_TYPE.UPDATE_CLIP_FIT_MODE]: { category: 'layout', label: 'Changed fit mode' },
  [CLIP_UPDATE_TYPE.UPDATE_CLIP_BORDERS_VISIBILITY]: { category: 'layout', label: 'Toggled borders' },
  [CLIP_UPDATE_TYPE.TOGGLE_ROUND_CORNERS]: { category: 'layout', label: 'Toggled rounded corners' },
  [CLIP_UPDATE_TYPE.UPDATE_PIP_SHAPE]: { category: 'layout', label: 'Changed PiP shape' },
  [CLIP_UPDATE_TYPE.UPDATE_PIP_POSITION]: { category: 'layout', label: 'Changed PiP position' },
  [CLIP_UPDATE_TYPE.UPDATE_CLIP_SPEAKER_DIRECTION]: { category: 'layout', label: 'Changed speaker direction' },
  [CLIP_UPDATE_TYPE.UPDATE_CLIP_SPEAKER_LABELS]: { category: 'layout', label: 'Toggled speaker labels' },
  [CLIP_UPDATE_TYPE.UPDATE_CLIP_SPEAKER_LABEL_STYLES]: { category: 'layout', label: 'Updated speaker labels' },
  [CLIP_UPDATE_TYPE.UPDATE_VISIBLE_FACE_IDS]: { category: 'layout', label: 'Changed visible speakers' },
  [CLIP_UPDATE_TYPE.UPDATE_VISIBLE_SPEAKERS]: { category: 'layout', label: 'Changed visible speakers' },
  [CLIP_UPDATE_TYPE.UPDATE_VISIBLE_VIDEO_IDS]: { category: 'layout', label: 'Changed visible feeds' },
  [CLIP_UPDATE_TYPE.UPDATE_TRACK_VISIBILITY]: { category: 'layout', label: 'Changed track visibility' },

  // Scenes
  [CLIP_UPDATE_TYPE.ADD_COMPOSITE_SCENE]: { category: 'scenes', label: 'Updated scenes' },
  [CLIP_UPDATE_TYPE.ADD_COMPOSITE_SCENE_RANGE]: { category: 'scenes', label: 'Updated scenes' },
  [CLIP_UPDATE_TYPE.REMOVE_COMPOSITE_SCENE]: { category: 'scenes', label: 'Updated scenes' },
  [CLIP_UPDATE_TYPE.UPDATE_COMPOSITE_SCENE]: { category: 'scenes', label: 'Updated scenes' },
  [CLIP_UPDATE_TYPE.UPDATE_SCENE_CROP_POSITION]: { category: 'scenes', label: 'Adjusted crop' },
  [CLIP_UPDATE_TYPE.TOGGLE_VIDEO_VISIBILITY_FROM_SCENE]: { category: 'scenes', label: 'Updated scenes' },
  [CLIP_UPDATE_TYPE.TOGGLE_VIDEO_VISIBILITY]: { category: 'scenes', label: 'Updated scenes' },

  // Overlays / Media
  [CLIP_UPDATE_TYPE.ADD_ELEMENT_TRACK]: { category: 'overlays', label: 'Added overlay' },
  [CLIP_UPDATE_TYPE.REMOVE_ELEMENT_TRACK]: { category: 'overlays', label: 'Removed overlay' },
  [CLIP_UPDATE_TYPE.UPDATE_ELEMENT_TRACK]: { category: 'overlays', label: 'Updated overlay' },
  [CLIP_UPDATE_TYPE.REPLACE_ELEMENT_TRACKS]: { category: 'overlays', label: 'Updated overlays' },
  [CLIP_UPDATE_TYPE.UPSERT_ELEMENT_TRANSITION]: { category: 'overlays', label: 'Added transition' },

  // Captions
  [CLIP_UPDATE_TYPE.TOGGLE_CAPTIONS]: { category: 'captions', label: 'Toggled captions' },
  [CLIP_UPDATE_TYPE.UPDATE_CAPTION_STYLES]: { category: 'captions', label: 'Updated caption style' },
  [CLIP_UPDATE_TYPE.UPDATE_CAPTION_PRESET]: { category: 'captions', label: 'Applied caption preset' },
  [CLIP_UPDATE_TYPE.UPDATE_CAPTIONS_POSITION]: { category: 'captions', label: 'Moved captions' },
  [CLIP_UPDATE_TYPE.UPDATE_WORD_HIGHLIGHT]: { category: 'captions', label: 'Updated word highlight' },
  [CLIP_UPDATE_TYPE.UPDATE_CLIP_FONT_LOCATION]: { category: 'captions', label: 'Changed font' },

  // Transcript
  [CLIP_UPDATE_TYPE.EDIT_WORD]: { category: 'transcript', label: 'Edited transcript' },
  [CLIP_UPDATE_TYPE.HIDE_WORD]: { category: 'transcript', label: 'Edited transcript' },
  [CLIP_UPDATE_TYPE.SHOW_WORD]: { category: 'transcript', label: 'Edited transcript' },
  [CLIP_UPDATE_TYPE.CORRECT_ALL]: { category: 'transcript', label: 'Corrected transcript' },

  // Misc
  [CLIP_UPDATE_TYPE.UPDATE_PLAYER_CONFIG_METADATA]: { category: 'settings', label: 'Updated settings' },

  // Flows that bypass the dispatchers and report a VERSION_EDIT_TYPE instead
  [VERSION_EDIT_TYPE.APPLY_TEMPLATE]: { category: 'template', label: 'Applied template' },
  [VERSION_EDIT_TYPE.LANGUAGE_SWITCH]: { category: 'language', label: 'Switched language' },
  [VERSION_EDIT_TYPE.AI_EDIT_APPLY]: { category: 'ai', label: 'Applied AI edit' },
  [VERSION_EDIT_TYPE.AI_QUICK_ACTION]: { category: 'ai', label: 'Applied AI quick action' },
  [VERSION_EDIT_TYPE.AI_ELEMENT_UPDATE]: { category: 'ai', label: 'Updated overlay with AI' },
  [VERSION_EDIT_TYPE.OVERLAY_ADD_IMAGE]: { category: 'overlays', label: 'Added image overlay' },
  [VERSION_EDIT_TYPE.OVERLAY_ADD_VIDEO]: { category: 'overlays', label: 'Added video overlay' },
  [VERSION_EDIT_TYPE.OVERLAY_ADD_AUDIO]: { category: 'overlays', label: 'Added audio overlay' },
  [VERSION_EDIT_TYPE.OVERLAY_UPDATE]: { category: 'overlays', label: 'Updated overlay' },
  [VERSION_EDIT_TYPE.OVERLAY_REMOVE]: { category: 'overlays', label: 'Removed overlay' },
  [VERSION_EDIT_TYPE.MOTION_GRAPHIC_ADD]: { category: 'overlays', label: 'Added motion graphic' },
  [VERSION_EDIT_TYPE.MOTION_GRAPHIC_UPDATE]: { category: 'overlays', label: 'Updated motion graphic' },
  [VERSION_EDIT_TYPE.CALLOUT_CAPTION_ADD]: { category: 'text', label: 'Added callout caption' },
  [VERSION_EDIT_TYPE.TEXT_UPDATE]: { category: 'text', label: 'Updated text' },
  [VERSION_EDIT_TYPE.CHAPTER_ADD]: { category: 'chapters', label: 'Added chapters' },
  [VERSION_EDIT_TYPE.CHAPTER_UPDATE]: { category: 'chapters', label: 'Edited chapters' },
  [VERSION_EDIT_TYPE.CHAPTER_REMOVE]: { category: 'chapters', label: 'Removed chapters' }
};

export default VERSIONS_DESCRIPTION_MAP;
